import SkyClickPlayer from "./custom/SkyClickPlayer";
import ObjectHelper from "../utils/ObjectHelper";

// *** OWN COMPONENTS ***
import ControlLayer from "./custom/ControlLayer";
import PlaylistNextButton from "./custom/PlaylistNextButton";
import PlaylistPreviousButton from "./custom/PlaylistPreviousButton";
import RelatedSwitcher from "./custom/RelatedSwitcher";
import RelatedViewer from "./custom/RelatedViewer";

export default class ComponentManager{

    static customComponentClasses:any[] = [
        ControlLayer,
        PlaylistNextButton,
        PlaylistPreviousButton,
        RelatedSwitcher,
        RelatedViewer
    ];

    /**
     * Component boot level 0:
     * Called once, to starting the static api action of custom components
     */
    static bootingStaticApi(){
        this.customComponentClasses.forEach(function(componentClass){
            // register component

            // extract name
            let componentName = ObjectHelper.getClassNameOfInstance(componentClass);

            // type assertions of component, to be able to register component on static videojs object
            // Workaround, because we can't define static type definitions in interfaces (https://stackoverflow.com/a/13955591)
            let staticComponent:VideoJSComponentStatic = componentClass as VideoJSComponentStatic;

            // register component
            SkyClickPlayer.vjs.registerComponent(componentName,staticComponent);
        });
    }


}


// WEBPACK FOOTER //
// ./src/app/components/ComponentManager.ts